<!-- Template -->
<div class="node-details-container">
  <mat-card class="mat-elevation-z2 main-card shadow-none">
    <mat-card-content class="pt-1 px-2">
      <section class="additional-information">
        <h2>Overview</h2>
        <div class="info-grid-compact">
          <div class="info-item-compact">
            <span
              class="label"
              triggers="hover"
              ngbTooltip="Administrator for user"
              >AdminId</span
            >
            <span class="value">{{ users?.adminId || "-" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">First Name</span>
            <span class="value">{{ users?.firstName || "-" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Last Name</span>
            <span class="value">{{ users?.lastName || "-" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Username</span>
            <span class="value">{{ users?.userName || "-" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Allocated Cores</span>
            <span class="value">{{
              users?.allocatedCoreQuota >= 0
                ? users?.allocatedCoreQuota || "-"
                : "Unlimited"
            }}</span>
          </div>
          @if(multipleEmailIds.length == 0){
          <div class="info-item-compact">
            <span class="label">Email Id</span>
            <span
              class="value"
              placement="left"
              container="body"
              triggers="hover"
              [ngbTooltip]="users?.emailId || 'NA'"
            >
              {{ users?.emailId ? (users.emailId | sliceEmail : 60) : "NA" }}
            </span>
          </div>
          } @else {
          <div class="info-item-compact">
            <span class="label">Email Id</span>
            <select class="form-select">
              <option *ngFor="let email of multipleEmailIds" [value]="email">
                {{ email }}
              </option>
            </select>
            <span class="value" *ngIf="!node?.mappedUsers?.length">NA</span>
          </div>
          }
          <div class="info-item-compact">
            <span class="label">Create Time</span>
            <span class="value">{{
              users?.createTime ? (users.createTime | date : "medium") : "NA"
            }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Additional Information</span>
            @if(users?.additionalInfo){
            <span
              class="value"
              placement="right"
              container="body"
              [autoClose]="true"
              triggers="hover"
              [ngbTooltip]="htmlContentTooltip"
            >
              {{ users.additionalInfo | shortenString : 200 }}
            </span>
            } @else {
            <span class="value">NA</span>
            }
          </div>
        </div>
      </section>
      <mat-divider></mat-divider>
      <section class="additional-information">
        <h2>Access Control</h2>
        <app-user-access-control></app-user-access-control>
      </section>
      <mat-divider></mat-divider>
      <section class="additional-information">
        <h2>Group Control</h2>
        @if(userGroup != null) {
        <div class="overflow-auto">
          <table class="table table-hover">
            <thead>
              <tr class="table-list-head">
                <th resizable scope="col">Sr no.</th>
                <th resizable scope="col">Group Name</th>
                <th resizable scope="col">Created By</th>
                <th resizable scope="col">Deployment</th>
                <th resizable scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="table-list-row"
                *ngFor="let group of userGroup; let i = index"
              >
                <td>{{ i + 1 }}</td>
                <td>{{ group.name }}</td>
                <td>{{ group.createdBy }}</td>
                <td>
                  @if(group.groupsProfileInfo != null){
                  <select style="padding: 2px">
                    <option *ngFor="let prof of group.groupsProfileInfo">
                      {{ prof.deploymentName }}
                    </option>
                  </select>
                  }@else {
                  <span>NA</span>
                  }
                </td>
                <td>
                  <button
                    (click)="removeUser(group.name)"
                    class="fs-5"
                    style="
                      border-radius: 3px;

                      outline: none;
                      min-width: fit-content;
                      border: none !important;
                      margin: 0 0.5rem !important;
                      height: 100%;
                      font-weight: 500;
                      color: var(--s-primary-color);
                      background-color: transparent;
                    "
                    triggers="hover"
                    ngbTooltip="Remove user from group"
                  >
                    <span><i class="bi bi-x-lg"></i></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        }@else {
        <p>No Group Attached To User</p>
        }
      </section>
    </mat-card-content>
  </mat-card>
  <!-- Loading Spinner -->
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    name="userDetailsLoad"
    [fullScreen]="false"
  ></ngx-spinner>
</div>

<ng-template #htmlContentTooltip>
  <div [innerHTML]="users.additionalInfo | safeHtml"></div>
</ng-template>
